import * as React from 'react';

import * as styles from './pageCenter.css';

export const OfferCardPageLayoutCenter = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['center']}>{props.children}</div>;
};
